import { render } from "./PetCard.vue?vue&type=template&id=72aeb35d&scoped=true"
import script from "./PetCard.vue?vue&type=script&lang=js"
export * from "./PetCard.vue?vue&type=script&lang=js"

import "./PetCard.vue?vue&type=style&index=0&id=72aeb35d&scoped=true&lang=sass"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aeb35d"]])

export default __exports__